/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Test_RunningInputs */

const en_admin_settings_test_running = /** @type {(inputs: Admin_Settings_Test_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running...`)
};

/**
* | output |
* | --- |
* | "Running..." |
*
* @param {Admin_Settings_Test_RunningInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_running = /** @type {((inputs?: Admin_Settings_Test_RunningInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_RunningInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_test_running(inputs)
});
export { admin_settings_test_running as "admin.settings.test.running" }